var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.76 155.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a896c6d8-50a6-4fbc-a6fe-7cc57f1ca98f{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a8b415fa-a3b3-48f1-bb57-69d22fd2d0e6",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a896c6d8-50a6-4fbc-a6fe-7cc57f1ca98f",
    d: "M131.22,3H72.36a3.6,3.6,0,0,0-1.83.5L42.41,19.74a3.66,3.66,0,0,0,0,6.33L74.3,44.41a3.65,3.65,0,0,1,1.83,3.17v62.08a3.65,3.65,0,0,1-1.79,3.14L7.54,152.33"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.19d6663b.svg";
export { ForwardRef as ReactComponent };